import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { setIn } from 'formik';

import SrSimpleDropdown from 'client/components/SrSimpleDropdown';
import UserActions from 'client/actions/User';

class SrUserSettingDropdown extends Component {
  static propTypes = {
    user: PropTypes.object,
    settingField: PropTypes.string,
    settingValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.array,
    ]),
    optionTitle: PropTypes.string,
    title: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      label: PropTypes.node.isRequired,
    })).isRequired,
    onChange: PropTypes.func.isRequired,
    multiple: PropTypes.bool,
    footer: PropTypes.node,
    dispatch: PropTypes.func,
    shouldUpdateSettings: PropTypes.bool,
  }

  static defaultProps = {
    shouldUpdateSettings: true,
  }

  _onDropdownChange = (settingValue) => {
    this.props.onChange(settingValue);
    this._updateUserSettings(settingValue);
  }

  _updateUserSettings = (newSettingValue) => {
    const { user, settingField, shouldUpdateSettings, dispatch } = this.props;
    if (shouldUpdateSettings) {
      const newUserSettings = setIn({ ...user.settings }, settingField, newSettingValue);
      dispatch(UserActions.updateSettings, newUserSettings);
    }
  }

  _getDropdownTitle = () => {
    const { options, optionTitle, settingValue } = this.props;
    const settingValueArray = Array.isArray(settingValue) ? settingValue : [settingValue];
    const optionsActive = options
      .filter(({ value }) => (
        Array.isArray(value) ? settingValueArray.includes(value[0]) : settingValueArray.includes(value))
      )
      .map(({ label }) => label)
      .join(', ');

    return `${optionTitle}: ${optionsActive || '...'}`;
  }

  render() {
    const {
      options,
      settingValue,
      multiple,
      footer,
      title,
    } = this.props;
    const settingValueArray = Array.isArray(settingValue) ? settingValue : [settingValue];
    const settingLabelArray = settingValueArray.map((value) => {
      const option = options.find((opc) => {
        return Array.isArray(opc.value) ? !!opc.value && opc.value.includes(value) : opc.value === value;
      });

      return option?.label;
    });

    return (
      <SrSimpleDropdown
        title={title || this._getDropdownTitle()}
        options={options.map((option) => ({
          id: option.value,
          title: option.label,
          isActive: settingLabelArray.includes(option.label),
        }))}
        onChange={this._onDropdownChange}
        multiple={multiple}
        footer={footer}
      />
    );
  }
}

SrUserSettingDropdown.displayName = 'SrUserSettingDropdown';

export default SrUserSettingDropdown;
